<script context="module">export const META = {
  height: 200,
  topMargin: 18,
  bottomMargin: 0,
  leftMargin: 100,
  // ...when font-size set to 12px and 7 character ticks
  rightMargin: 0
};
</script>

<script>import * as d3 from "d3";
import { okhsl } from "../../../d3-mapp/color/index.js";
import ScalarAxis from "../ScalarAxis.svelte";
import {} from "../types.js";
import {
  timeRangeContextKey
} from "../time-plot-context.js";
import { uuid } from "../../../constants/uuid.const.js";
import { getContext } from "svelte";
export let title = void 0;
export let label;
export let labelSwatch = void 0;
export let showAxis = true;
export let height = META.height;
export let data;
export let color = okhsl("steelblue");
const {
  timeScale,
  tickTextMetrics,
  plotConfigMap,
  setPlot
} = getContext(timeRangeContextKey);
const id = uuid();
$:
  params = {
    id,
    height,
    margin: [
      META.topMargin,
      META.rightMargin,
      META.bottomMargin,
      META.leftMargin
    ],
    axis: showAxis,
    histogram: false,
    thresholds: false
  };
$: {
  setPlot(params);
}
$:
  config = $plotConfigMap.get(id);
let yScale;
const topMargin = META.topMargin;
$:
  plotHeight = height - topMargin;
let ticks = void 0;
$: {
  const maxValue = data.reduce(
    (max, interval) => Math.max(max, interval.f),
    Number.NEGATIVE_INFINITY
  );
  const yExtent = [0, maxValue];
  const yRange = [plotHeight + topMargin, topMargin];
  yScale = d3.scaleLinear(yExtent, yRange).nice();
  const scalarTickHeight = tickTextMetrics.actualBoundingBoxAscent + tickTextMetrics.actualBoundingBoxDescent;
  const maxTicks = Math.floor(plotHeight / scalarTickHeight) + 1;
  ticks = maxValue > 0 ? maxValue < 10 ? maxValue : void 0 : 1;
  ticks = ticks !== void 0 ? Math.min(ticks, maxTicks) : maxTicks;
}
</script>

{#if $timeScale}
  <g
    class="frequencyBar seriesPlot plot"
    transform={config?.transform}
    data-plot={id}
  >
    {#if title && title.length > 0}
      <title>{title}</title>
    {/if}
    <g
      class={`left ${config?.axis ? "" : "hidden"}`}
      transform="translate({config ? config.leftIndent : META.leftMargin},0)"
      ><ScalarAxis scale={yScale} {label} {labelSwatch} ether={0} {ticks} /></g
    >
    <g>
      {#each data as datum (datum.key)}
        <rect
          stroke="none"
          y={yScale(datum.f)}
          height={yScale(0) - yScale(datum.f)}
          x={$timeScale(datum.start)}
          width={$timeScale(datum.end) - $timeScale(datum.start)}
          fill={color.formatHex()}
          fill-opacity={color.opacity}
        />
      {/each}
    </g>
  </g>
{/if}
